import React, { Component } from 'react';
import Hero from '../../modules/Hero/Hero';
import globals from '../../globals';
import NbnPlans from '../NbnPlans/NbnPlans';
import sqAnimations from './sqAnimations';
import HelmetDefault from "../../layout/HelmetDefault";
import Heading from '../../elements/Heading';
import OwlCarousel from "react-owl-carousel2";
import SecondHeading from "../../modules/SecondHeading";
import content from "../../../../data/small-business/nbn-need-to-know.json";
import ThingsToKnow from "../../modules/ThingsToKnow";
import ExpandableListModule from '../../modules/ExpandableListModule';
import nbnData from '../../../../data/small-business/nbn-about-nbn.json';
import qnaData from '../../../../data/small-business/nbn-qna.json';
import termsData from '../../../../data/small-business/nbn-terms.json';
import FaqStructuredData from '../../components/FaqStructuredData';
import { appendAgentTokenInput } from '../../utils/agentUtil';
import DataSource from '../../DataSource'
import { BRAND_EXETEL, UNCONNECTED_SERVICES_CAMPAIGNS } from '../../constants';
import { appendGenesysIdInput } from '../../utils/addGenesysId';
import { appendUtmSourceId } from '../../utils/utmUtil';

class Nbn extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            leadCopy: [],
            features: [],
            bannerSlider: [],
            seoTitle: '',
            seoDescription: '',
            dataReceived: false,
            whyChooseUs: { list: [] },
            secondHeading: {},
            caseStudies: [],
            // SQ field
            address: '',
            addressList: [],
            sqClass: 0,
            selectedNbnType: '',
            sqErrorMsg: '',
            availableSpeed: globals.getLocalVar('nbnSpeed', 100),
            nbnRegion: '',
            response: '',
            hasError: false,
            locationId: [globals.getSqFromSessionStorage().locId ? globals.getSqFromSessionStorage().locId : null],
            providerName: [globals.getSqFromSessionStorage().priority ? globals.getSqFromSessionStorage().priority : null],
            activeService: 0,
            serviceLocationId: ''
        };

        this.timeout = null
        this.errorResults = [{ address: 'Oops! It appears something went wrong with your search.', value: false }]
    }

    componentDidMount() {
        this.getData();
        // this.setState({ locationId: [sqObject.locId ? sqObject.locId : null], providerName: [sqObject.priority ? sqObject.priority : null] })
    }

    /****************************************************************************************/

    /*                              SQ FIELD METHODS BEGIN                                  */

    /****************************************************************************************/

     // Step 1 - Submit SQ
    async handleSqSubmit (sqField) {
        if (this.state.address.trim() !== '') {
            sqAnimations.showLoader(sqField);
            let tl = sqAnimations.triggerProgressBar(sqField);
            globals.pushGA4Events("sqAddressSubmitBusiness", {
                eventInfo: {
                    userPostCode: globals.sqAddressResult(this.state.address).userPostcode,
                    UserState: globals.sqAddressResult(this.state.address).userState,
                    pageCategory: "Business"
                }
            });
            
            const onSuccess = response => {
                sqAnimations.completeLoader(sqField, tl);
                this.setState({ hasError: false })
                this.setState({ response: response, availableSpeed: response.maxSpeed })
                globals.setLocalVar('nbnSpeed', response.maxSpeed);
                this.setSqClass(response.nbnServiceClass);
                this.setState({activeService: response.activeService, serviceLocationId: response.serviceLocationId})
                if (response.services.includes('nbn')) {
                    globals.setSessionVar('sq', JSON.stringify(response))
                } else {
                    globals.setSessionVar('sq', '')
                }

                globals.pushGA4Events("sqSubmitSuccessBusiness", {
                    eventInfo: {
                        technologyType: response.nbnType,
                        userPostCode: globals.sqAddressResult(this.state.address).userPostcode,
                        userState: globals.sqAddressResult(this.state.address).userState,
                        pageCategory: "Business",
                        unconnected: response.campaigns.includes(UNCONNECTED_SERVICES_CAMPAIGNS)  
                    }
                });
                sqAnimations.showSuccess(sqField)
                this.getData.bind(this)
            }

            const params = {}
            if (this.state.providerName.length > 0) {
                this.state.providerName.forEach((provider, index) => {
                    if (/(nbn)/i.test(provider)) {
                        return (
                            params[provider.toLowerCase()] = this.state.locationId[index]
                        )
                    }
                })
            }

            params['brand'] = BRAND_EXETEL

            await DataSource.getServiceQualification(params, response => {
                const apiResponse = this.state.providerName.length > 1 ? response.sqSummary.nbn : response.sqSummary[this.state.providerName[0].toLowerCase()]

                const result = {
                    nbnServiceClass: apiResponse.serviceClass,
                    nbnNewDev: apiResponse.newDevelopmentsChargeApplies,
                    nbnType: apiResponse.technologyShortCode ? apiResponse.technologyShortCode: apiResponse.technology,
                    nbnRegion: 'metro',
                    locId: apiResponse.locationId,
                    flipReady: apiResponse.alternativeTechnologyDetails && apiResponse.alternativeTechnologyDetails.readyStatus ? apiResponse.alternativeTechnologyDetails.readyStatus : false,
                    flipDate: apiResponse.alternativeTechnologyDetails && apiResponse.alternativeTechnologyDetails.readyDate ? apiResponse.alternativeTechnologyDetails.readyDate : "",
                    nbnReadyDate: apiResponse.readyDate,
                    maxSpeed: apiResponse.maximumDownloadSpeed,
                    earliestChangeoverDate: null,
                    completedDate: null,
                    services: this.state.providerName.map(name => name === 'NBN' || name === 'nbn' ? 'nbn' : 'fibre'),
                    additionalServices: [],
                    categories: response.sqSummary.availablePlanCategories,
                    priority: response.sqSummary ? response.sqSummary.priority[0] : '',
                    campaigns: apiResponse.campaigns && apiResponse.campaigns.length > 0 ? apiResponse.campaigns : [],
                    activeService: apiResponse.activeService,
                    serviceLocationId: apiResponse.locationId
                }

                onSuccess(result)
            }, () => {
                this.handleErrorResponse(sqField, tl)
            })
        }
    }

    handleAddressClick(address, sqField) {
        if (address.address) {
            this.setState({ locationId: address.locationId, providerName: address.name, address: address.address }, () => {
                this.searchAddress(address.address, sqField)
            })
        }
    }

    handleEnterPress(sqField) {
        /*
            If the user presses enter while there are addresses in state then
            automatically submit the first value
        */
        if (this.state.addressList.length > 0) {
            this.handleAddressClick(this.state.addressList[0], sqField);
        } else {
            this.handleSqSubmit(sqField);
        }
    }

    handleSetAddressList(addressList) {
        this.setState({addressList: addressList})
    }

    setSqClass(sqClass) {
        this.setState({
            sqClass: sqClass
        });
    }

    setSqErrorMsg(message) {
        this.setState({
            sqErrorMsg: message
        });
    }

    handleErrorResponse (sqField, tl) {
        globals.pushEvent('nbnAddressSqNegative');
        globals.pushGA4Events("sqSubmitFailBusiness", {
            eventInfo: {
                addressOutcome: "Service is not available",
                userPostCode: globals.sqAddressResult(this.state.address).userPostcode,
                userState: globals.sqAddressResult(this.state.address).userState,
                pageCategory: "Business"
            }
        });
        sqAnimations.completeLoader(sqField, tl);
        sqAnimations.resetSq(sqField);
        this.setState({ hasError: true });
    }

    resetAddressList() {
        this.setState({
            addressList: []
        });
    }

    searchAddress(address, sqField) {
        if (address && this.state.locationId && this.state.providerName) {
            this.handleSqSubmit(sqField)
        }
    }

    /****************************************************************************************/

    /*                                  OTHER METHODS BEGIN                                 */

    /****************************************************************************************/

    getData() {
        fetch('/api/small-business/nbn')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    handleSubmitOrder(cart, event) {
        let form = document.createElement('form');

        cart.sq_address = globals.encryptData(this.state.address); 
        cart.service_class = this.state.sqClass;
        cart.new_dev = 0;
        cart.type = 'broadband';
        cart.technology = 'nbn'; //todo: This could also be fibre, but not reqd for smb tracking currently
        cart.smb = 1;
        cart.active_service = this.state.activeService
        cart.service_location_id = this.state.serviceLocationId

        Object.keys(cart).map((key) => {
            let input = document.createElement('input');
            input.name = key;
            input.type = 'hidden';
            input.value = cart[key];
            form.appendChild(input);
        });

        globals.pushEvent('nbnOrderNowButton');

        appendAgentTokenInput(form)
        appendUtmSourceId(form)
        appendGenesysIdInput(form)

        form.method = 'GET';
        form.action = process.env.MIX_APP_ORDER_FORM_URL;
        
        document.body.appendChild(form);
        form.submit();
    }

    scrollToForm(event) {
		event.preventDefault();
		let form = document.getElementById('nbn-plan-container');
		TweenMax.to(window, 0.5, {scrollTo: (form.offsetTop - 70)});
    }

    handleClickCta(event) {
        this.scrollToForm(event)
        globals.pushGA4Events('bannerCtaClick', {
            eventInfo: {
                clickText: "View Plans",
                clickUrl: window.location.href,
                pageCategory: 'Business'
            }
        })
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived}>
                    <div className="nbn-container">
                        <h3 className="mt-5 mb-1">5 FREE Speed Upgrade Days a month</h3>
                        <p className='mt-0'>Only applicable to the Home Business nbn™ and Start-up nbn™ plans – full details available <a href='https://www.exetel.com.au/speed-boost'>here</a></p>
                        <ul>
                            <li>Unlimited business nbn™ plans from $70/mth</li>
                            <li>Help guarantee within 5 minutes or $10 credit applied</li>
                            <li>Support available whenever you need it, including prioritised calls during extended business hours</li>
                            <li>Free WiFi modem on all plans</li>
                        </ul>
                        <div className="d-block">
                            <a className="view-btn mt-3 d-inline-block" href="#" onClick={(event) => this.handleClickCta(event)}>
                                <img src="/images/view-plan-btn.svg" alt="view-btn" />
                            </a>
                        </div>
                    </div>
                </Hero>
                <NbnPlans
                    address={this.state.address}
                    response={this.state.response}
                    handleSqSubmit={this.handleSqSubmit.bind(this)}
                    handleSetAddressList={this.handleSetAddressList.bind(this)}
                    handleAddressClick={this.handleAddressClick.bind(this)}
                    handleEnterPress={this.handleEnterPress.bind(this)}
                    handleSubmitOrder={this.handleSubmitOrder.bind(this)}
                    resetAddressList={this.resetAddressList.bind(this)}
                    setSqErrorMsg={this.setSqErrorMsg.bind(this)}
                    addressList={this.state.addressList}
                    selectedNbnType={this.state.selectedNbnType}
                    availableSpeed={this.state.availableSpeed}
                    nbnRegion={this.state.nbnRegion}
                    sqClass={this.state.sqClass}
                    nbnMaxSpeed={this.state.availableSpeed}
                    hasError={this.state.hasError}
                />
                <div className="why-choose-us">
                    <Heading title={this.state.whyChooseUs.title} subTitle={this.state.whyChooseUs.subTitle} />
                    <div className="choose-container">
                        {this.state.whyChooseUs.list.map((item, key) => {
                            return (
                                <div key={key} className="choose">
                                    <div className="choose-copy">
                                        <h5 className="m-0 mb-3">{item.title}</h5>
                                        <p className="m-0">{item.content}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="second-heading-wrapper">
					<div className="inner">
						<SecondHeading data={this.state.secondHeading}>
                            <div className="case-studies mt-3">
                                {this.state.caseStudies.length > 0 ?
                                    <OwlCarousel options={{
                                        items: 1,
                                        loop: true,
                                        autoHeight: false,
                                        autoplay: true
                                    }}>
                                        {this.state.caseStudies.map((item, key) => {
                                            return (
                                                <div key={key} className="case-study">
                                                    <div className="logo">
                                                        <img src={`/images/logos/${item.logo}`} alt={item.logo} />
                                                    </div>
                                                    <div className="quote">
                                                        <p>"{item.quote}"</p>
                                                    </div>
                                                    <p className="author" dangerouslySetInnerHTML={{__html: item.author}} />
                                                </div>
                                            );
                                        })}
                                    </OwlCarousel>
                                : ''}
                            </div>
                        </SecondHeading>
					</div>
                </div>
                <ThingsToKnow data={content.needToKnow}/>
                <FaqStructuredData faqs={[...nbnData.data, ...qnaData.data, ...termsData.data]}  />
                <div className="about-nbn" id="about-nbn">
                    <ExpandableListModule data={nbnData.data} title={nbnData.title} />
                </div>
                <div className="qan">
                    <ExpandableListModule data={qnaData.data} title={qnaData.title} />
                </div>
                <div className="terms-nbn">
                    <ExpandableListModule data={termsData.data} title={termsData.title} description={termsData.leadCopy[0]} />
                </div>
            </div>
        );
    }

}

export default Nbn;



// WEBPACK FOOTER //
// ./resources/assets/js/nbn/Nbn/Nbn.js